// extracted by mini-css-extract-plugin
module.exports = {"container":"_25d45facb5--container--b6Wb4","icon":"_25d45facb5--icon--MRGNr"};